module.exports = __webpack_public_path__ + "media/application/images/demsoc/hero/polychrome_1-7b87c273df07601450b31b17dc15d367.jpg";